const actionTypeIdentifier = 'DD7F53BC-691A-40F6-B279-EC1188FFA821';

export const getAdminSetting = `GET-ADMIN-SETTING-${actionTypeIdentifier}`;
export const setDateFormat = `SET-ADMIN-SETTING-DATE-FORMAT-${actionTypeIdentifier}`;
export const setTimeZone = `SET-ADMIN-SETTING-TIMEZONE-${actionTypeIdentifier}`;


export const getWorkflowList = `USER-ADMIN-GET-WORKFLOWLIST-${actionTypeIdentifier}`;
export const setGetWorkListError = `USER-ADMIN-GET-WORKFLOWLIST-ERROR-${actionTypeIdentifier}`;
export const getServicetypelist = `USER-ADMIN-GET-SERVICETYPELIST-${actionTypeIdentifier}`;
export const getServicetypelistError = `USER-ADMIN-GET-SERVICETYPELIS-ERROR-${actionTypeIdentifier}`;
export const setsave = `SET-APPROVAL-APPROVAL-SETTING-TIMEZONE-${actionTypeIdentifier}`;